import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import { Reveal } from "@/components/Reveal";

const FAQ = () => {
  const [open, setOpen] = useState(0);
  const { faqs } = useContent();

  return (
    <div data-testid="faq-page" className="pt-36 md:pt-48 pb-28">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <Reveal>
              <p className="text-[0.65rem] uppercase tracking-[0.4em] text-gold mb-6">Questions</p>
              <h1 className="font-serif text-5xl md:text-7xl font-light tracking-tight leading-none">
                Good to <span className="italic text-beige">know.</span>
              </h1>
              <p className="mt-8 text-muted2 leading-relaxed">
                A few of the things clients ask most. If your question isn't here, I'm only a message away.
              </p>
              <Link to="/contact" data-testid="faq-contact-link" className="inline-block mt-8 text-xs uppercase tracking-[0.25em] text-cream/70 hover-line">
                Ask Directly →
              </Link>
            </Reveal>
          </div>

          <div className="md:col-span-7 md:col-start-6">
            {faqs.map((f, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <div className="border-t border-white/10 last:border-b" data-testid={`faq-item-${i}`}>
                  <button
                    onClick={() => setOpen(open === i ? -1 : i)}
                    data-testid={`faq-toggle-${i}`}
                    className="w-full flex items-center justify-between gap-6 py-7 text-left group"
                  >
                    <span className="font-serif text-2xl md:text-3xl font-light group-hover:text-gold transition-colors duration-500">{f.q}</span>
                    <motion.span animate={{ rotate: open === i ? 45 : 0 }} transition={{ duration: 0.4 }} className="text-gold shrink-0">
                      <Plus size={24} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {open === i && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="pb-8 pr-10 text-muted2 leading-relaxed text-lg font-light max-w-2xl">{f.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
